import { render, staticRenderFns } from "./KitConfiguration.vue?vue&type=template&id=70476e5d"
import script from "./KitConfiguration.vue?vue&type=script&lang=js"
export * from "./KitConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports